import {Component, Prop, h, Element, Event, EventEmitter, Host, Method} from '@stencil/core';

@Component({
    tag: 'joy-toggle',
    styleUrl: 'toggle.scss',
    scoped: true,
})
export class Toggle {
    @Element() el!: HTMLJoyToggleElement;

    /** Input value. TODO : check if we really need it as we use a checkbox system */
    @Prop({reflect: true, mutable: true}) value?: string;

    /** It will be applied as the hidden input name attribute (for the actual form) */
    @Prop({reflect: true}) name = '';

    /** Disabled state */
    @Prop({reflect: true}) disabled = false;

    /** Toggle activated or not */
    @Prop({mutable: true, reflect: true}) checked = false;

    /** Clicking on the component will fire this customEvent. */
    @Event({eventName: 'joy-toggle-change'}) joyToggleChange!: EventEmitter<boolean>;

    /** Clicking on the component will fire this customEvent. */
    @Event({eventName: 'value-change'}) valueChange!: EventEmitter<boolean>;

    /**
     * Update toggle value from outside the component
     * @param {Boolean} newValue true or false...
     */
    @Method()
    async updateValue(newValue: boolean): Promise<void> {
        this.value = `${newValue}`;
        this.checked = newValue;
    }

    private onChange = () => {
        /**
         * As the actual checkbox is hidden is order to style the toggle
         * We can't change its value with default behavior, so we simply bind its checked attribute to our component Prop value
         */
        if (!this.disabled) {
            this.checked = !this.checked;
            this.value = `${this.checked}`;
            this.valueChange.emit(this.checked);
            this.joyToggleChange.emit(this.checked);
        }
    };

    render() {
        return (
            <Host>
                <label
                    class={{
                        'joy-toggle': true,
                        'joy-toggle__checked': this.checked,
                        'joy-toggle__disabled': this.disabled,
                    }}
                >
                    <input
                        type="checkbox"
                        class="joy-toggle__input"
                        role="checkbox"
                        disabled={this.disabled}
                        checked={this.checked}
                        onChange={this.onChange}
                        aria-checked={`${this.checked}`}
                        value={this.value}
                        name={this.name}
                    />
                    <p class="joy-toggle__content">
                        <span class="joy-toggle__content-label">
                            <slot />
                        </span>
                        <span class="joy-toggle__smile">
                            <svg width="18" height="10" viewBox="0 0 18 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.0237 9.14856C15.7144 9.14856 17.8736 2.22231 17.9649 1.91853L17.9345 1.94891C18.1778 1.15908 17.7216 0.308485 16.9309 0.0654591C16.1402 -0.177566 15.2886 0.278108 15.0453 1.06794C14.9845 1.25021 13.5551 6.11073 8.99328 6.11073C4.43147 6.11073 3.03249 1.43248 2.97167 1.21983C2.75878 0.399622 1.90724 -0.0560541 1.11652 0.156593C0.295397 0.369241 -0.160787 1.18945 0.0520982 2.00967C0.721165 4.4703 3.48869 9.14856 9.0237 9.14856Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </span>
                    </p>
                </label>
            </Host>
        );
    }
}
